import { useMemo } from "react";

import { useCreateAccountQuery } from "./createAccountQuery";

export interface StartPageConfig {
  // TODO: can get more granular (i.e. mail, email, text opt in)
  // I'm deferring for now
  allowUpdateNotificationPreferences: boolean;
  showTermsConditions: boolean;
  // TODO: can get more granular (e.g. which _parts_ of order summary to show?)
  showOrderSummary: boolean;
  customerInfo: {
    showBillingAddress: boolean;
  };
  redirectToParentApp: boolean;
  redirectToIntroSurvey: boolean;
  // business context here:
  // https://mighteor.atlassian.net/browse/MW-6190
  showMcsConsentToTreat: boolean;
}

const PAGE_CONFIG_GREENSHIELD: StartPageConfig = {
  allowUpdateNotificationPreferences: true,
  showTermsConditions: true,
  showOrderSummary: false,
  customerInfo: {
    showBillingAddress: false,
  },
  redirectToParentApp: false,
  redirectToIntroSurvey: true,
  showMcsConsentToTreat: false,
};

const PAGE_CONFIG_STANDARD_CHECKOUT: StartPageConfig = {
  allowUpdateNotificationPreferences: false,
  showTermsConditions: false,
  showOrderSummary: true,
  customerInfo: {
    showBillingAddress: true,
  },
  redirectToParentApp: true,
  redirectToIntroSurvey: false,
  showMcsConsentToTreat: false,
};

const PAGE_CONFIG_MCS: StartPageConfig = {
  allowUpdateNotificationPreferences: false,
  showTermsConditions: false,
  showOrderSummary: true,
  customerInfo: {
    showBillingAddress: true,
  },
  redirectToParentApp: true,
  redirectToIntroSurvey: false,
  showMcsConsentToTreat: true,
};

export const useStartPageConfig = (): StartPageConfig | undefined => {
  const { data: lambdaResp } = useCreateAccountQuery();

  const progPlanHasGreenshieldTag =
    lambdaResp?.order.program_plan_obj.tag.includes("GREENSHIELD");

  return useMemo(() => {
    if (!lambdaResp) {
      return;
    }

    if (progPlanHasGreenshieldTag) {
      return PAGE_CONFIG_GREENSHIELD;
    }

    if (lambdaResp.order.program_plan_obj.tag.includes("MCS")) {
      return PAGE_CONFIG_MCS;
    }

    return PAGE_CONFIG_STANDARD_CHECKOUT;
  }, [lambdaResp, progPlanHasGreenshieldTag]);
};
